// extracted by mini-css-extract-plugin
module.exports = {"badge":"AdvertBadge_badge__jhauX","text":"AdvertBadge_text__XvXDI"};